import {h, Fragment} from "preact"
const MARKETING_BADGES = {
  "Best of Cratejoy": "Best of 2024",
  "Editor's Picks": "Editor's Picks 2024",
  "Top Rated": "Top Rated 2024",
  "Best New Box": "Best New Box 2024",
  "Best in Category": "Best in Category 2024",
  "Preferred Seller": "Preferred Seller",
};
export default ({ badges = [] }) => {
  const theBadge = badges.find(b => MARKETING_BADGES[b]);
  if (!theBadge) return;
  return (
    <div class="app--listing-card-badge">{theBadge}</div>
  );
};
